import { render, staticRenderFns } from "./InvoicesCreation.vue?vue&type=template&id=c83ca322&scoped=true"
import script from "./InvoicesCreation.vue?vue&type=script&lang=js"
export * from "./InvoicesCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83ca322",
  null
  
)

export default component.exports